import React from 'react';
import { Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';

import CompleteContact from '@bizapp-lp/workflow/pages/CompleteContact';
import CompleteTrialApplication from '@bizapp-lp/workflow/pages/CompleteTrialApplication';
import Home from '@bizapp-lp/workflow/pages/Home';
import ServiceSpec01 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0120210712';
import ServiceSpec02 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0220220307';
import ServiceSpec03 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0320220425';
import ServiceSpec04 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0420220627';
import ServiceSpec05 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0520230401';
import ServiceSpec06 from '@bizapp-lp/workflow/pages/specs/ServiceSpec0620230801';
import Sitemap from '@bizapp-lp/workflow/pages/internal/Sitemap';
import TrialSpec00 from '@bizapp-lp/workflow/pages/specs/TrialSpec0020210707';
import TrialSpec01 from '@bizapp-lp/workflow/pages/specs/TrialSpec0120220307';
import TrialSpec02 from '@bizapp-lp/workflow/pages/specs/TrialSpec0220220425';
import TrialSpec03 from '@bizapp-lp/workflow/pages/specs/TrialSpec0320220627';

import { theme } from '@bizapp-lp/workflow/styles/theme';

interface RedirectProps {
  to?: string;
}

const Redirect: React.FC<RedirectProps> = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to ?? 'https://www.worksap.co.jp/saas/workflow';
  }, [to]);
  return <></>;
};

const App: React.FC = () => {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [hash, pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Routes basename="/workflow">
        <Route
          path="/complete-contact"
          element={<CompleteContact isAllowedDirectAccess={true} />}
        />
        <Route
          path="/complete-trial-application"
          element={<CompleteTrialApplication isAllowedDirectAccess={true} />}
        />
        <Route
          path="/contact"
          element={<Redirect to="https://www.worksap.co.jp/contact/" />}
        />
        <Route
          path="/document-claim"
          element={
            <Redirect to="https://www.worksap.co.jp/saas/workflow/#form" />
          }
        />
        <Route
          path="/service-spec"
          element={
            <Redirect to="https://www.worksap.co.jp/services/spec/wf-spec/" />
          }
        />
        <Route
          path="/spec-archive"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route path="/service-spec-01-20210712" element={<ServiceSpec01 />} />
          <Route path="/service-spec-02-20220307" element={<ServiceSpec02 />} />
          <Route path="/service-spec-03-20220425" element={<ServiceSpec03 />} />
          <Route path="/service-spec-04-20220627" element={<ServiceSpec04 />} />
          <Route path="/service-spec-05-20230401" element={<ServiceSpec05 />} />
          <Route path="/service-spec-06-20230801" element={<ServiceSpec06 />} />
          <Route path="/trial-spec-00-20210707" element={<TrialSpec00 />} />
          <Route path="/trial-spec-01-20220307" element={<TrialSpec01 />} />
          <Route path="/trial-spec-02-20220425" element={<TrialSpec02 />} />
          <Route path="/trial-spec-03-20220627" element={<TrialSpec03 />} />
          <Route
            path="*"
            element={
              <Redirect to="https://www.worksap.co.jp/services/spec/wf-spec/" />
            }
          />
        </Route>
        <Route
          path="/trial-application"
          element={
            <Redirect to="https://customer.bizapp.worksap.co.jp/signup/workflow" />
          }
        />
        <Route
          path="/trial-spec"
          element={
            <Redirect to="https://www.worksap.co.jp/terms/saas/workflow/trial/latest.html" />
          }
        />
        <Route path="/internal">
          <Route path="/old-home" element={<Home />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="*" element={<Sitemap />} />
          <Route path="" element={<Sitemap />} />
        </Route>
        <Route path="*" element={<Redirect />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
